import { Injectable } from '@angular/core';
import dataURLtoBlob from 'blueimp-canvas-to-blob';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  constructor() {}

  downloadFile(dataURL: string, fileName: string = 'download.png'): void {
    const blob: Blob = dataURLtoBlob(dataURL);
    FileSaver.saveAs(blob, fileName);
  }

  createFormDataFile(files: File[], key: string): FormData {
    const formData: FormData = new FormData();
    files.forEach((file: File) => {
      if (file instanceof Blob) {
        formData.append(key, file, file.name);
      } else {
        formData.append(key, file);
      }
    });

    return formData;
  }

  blobToFile(blobFile: Blob, fileName: string): File {
    const blob: any = blobFile;
    blob.lastModifiedDate = new Date();
    blob.name = fileName;

    return blobFile as File;
  }
}
